import React from 'react';
import classNames from 'classnames';
import { ConnectedDynpackManager } from './DynpackManager';
import { SlideGroupContextProvider } from '../../components/SlideManager';
import { ConnectedSegmentManagerRoundTrip } from '../FlightsManager/Segment/SegmentManager/SegmentManagerRoundTripMobile';
import { RoomSelector } from '../RoomSelector/RoomSelectorMobile';
import { SearchButtonStyled } from '../SearchButton';
import { ResidentDiscount } from '../ResidentDiscount/ResidentDiscountMobile';
import { ABUtils, CMS } from '../../utils';
import { DP_SEARCH_FORM, withTrackComponentDisplayed } from '../../utils/HtmlEvents';

export const DynpackManagerMobile = withTrackComponentDisplayed(() => {
    const { isAbTrain, isCssVariationMobile, isHotelsVisibility } = ABUtils.getABs();
    const wrapperClassNames = classNames({
        'odf-space-inner-left-m odf-space-inner-right-m': !isCssVariationMobile,
        'prisma-responsive-space-horizontal': isCssVariationMobile,
        'odf-space-inner-top-m odf-bg-base': true,
        'od-flights-manager-wrapper': isHotelsVisibility
    });
    return (
        <ConnectedDynpackManager render={() => (
            <>
                <div className={wrapperClassNames}>
                    <SlideGroupContextProvider>
                        <ConnectedSegmentManagerRoundTrip />
                        <RoomSelector />
                    </SlideGroupContextProvider>

                    <ResidentDiscount />

                    <div className="odf-space-outer-top-m">
                        <SearchButtonStyled block dynPack>
                            { isAbTrain ? <CMS id="flightsManager.searchDynpack.TRAINS" /> : <CMS id="flightsManager.searchDynpack.main" /> }
                        </SearchButtonStyled>
                    </div>
                </div>
            </>
        )}
        />
    );
}, DP_SEARCH_FORM);
